<ul
  class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
  id="accordionSidebar"
>
  <a
    class="sidebar-brand d-flex align-items-center justify-content-center"
    style="background-color: white"
  >
    <div class="sidebar-brand-icon rotate-n-15"></div>
    <div class="sidebar-brand-text mx-3">
      <img style="object-fit: cover" [src]="retrievedImage" />
    </div>
  </a>

  <!-- Divider -->
  <hr class="sidebar-divider my-0" />

  <!-- Dashboard -->
  <li class="nav-item active">
    <a class="nav-link" routerLink="/dashboard">
      <i class="fas fa-fw fa-tachometer-alt"></i>
      <span>Bảng điều khiển</span>
    </a>
  </li>

  <hr class="sidebar-divider" />

  <!-- Catalogs -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo">
      <i class="fas fa-fw fa-book"></i>
      <span>Danh mục</span>
    </a>
    <div id="collapseTwo" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Danh mục :</h6>

        <a class="collapse-item" routerLink="/category">Danh mục sách</a>

        <a class="collapse-item" routerLink="/book">
          Tài liệu
          <span class="badge badge-pill badge-danger small-radius ml-2">
            {{ dashboardAnalytics?.bookNumber }}
          </span>
        </a>

        <h6 class="collapse-header">Quản lý danh mục :</h6>

        <a class="collapse-item" routerLink="/archived-books">Sách lưu trữ</a>
        <a class="collapse-item" routerLink="/destroyed-books">Sách hủy</a>

        <h6 class="collapse-header">Thư viện 3D</h6>
        <a class="collapse-item" routerLink="/shelf-viewer">Xem kệ sách</a>

        <h6 class="collapse-header">Thiết lập :</h6>
        <a class="collapse-item" routerLink="/publisher">Nhà xuất bản</a>
        <a class="collapse-item" routerLink="/writer">Tác giả</a>
        <a class="collapse-item" routerLink="/item-types">Loại tài liệu</a>
      </div>
    </div>
  </li>

  <!-- Members -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#membreUtilities">
      <i class="fas fa-fw fa-users"></i>
      <span>Thành viên</span>
    </a>
    <div id="membreUtilities" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Thành viên</h6>

        <a class="collapse-item" routerLink="/type-member">Loại thành viên</a>

        <a class="collapse-item" routerLink="/member">
          Danh sách thành viên
          <span class="badge badge-pill badge-danger small-radius ml-2">
            {{ dashboardAnalytics?.memberNumber }}
          </span>
        </a>
      </div>
    </div>
  </li>

  <hr class="sidebar-divider" />

  <!-- Circulation -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#circulation">
      <i class="fas fa-fw fa-clipboard"></i>
      <span>Lưu thông</span>
    </a>
    <div id="circulation" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Lưu thông</h6>

        <a class="collapse-item" routerLink="/circulation">Giao dịch</a>
        <a class="collapse-item" routerLink="/circulation-calendar">Lịch</a>
        <a class="collapse-item" routerLink="/circulation-status">Trạng thái</a>
      </div>
    </div>
  </li>

  <!-- Overdues -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#overdues">
      <i class="fas fa-fw fa-clock"></i>
      <span>Quá hạn</span>
    </a>
    <div id="overdues" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Tài khoản:</h6>
        <a class="collapse-item" routerLink="/overdue">Quá hạn</a>
      </div>
    </div>
  </li>

  <!-- Acquisitions -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#acquisitionsUtilities">
      <i class="fas fa-fw fa-shopping-cart"></i>
      <span>Thu mua</span>
    </a>
    <div id="acquisitionsUtilities" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Tài khoản:</h6>

        <a class="collapse-item" routerLink="/vendor">Nhà cung cấp</a>
        <a class="collapse-item" routerLink="/basket">Giỏ hàng</a>
        <a class="collapse-item" routerLink="/contract">Hợp đồng</a>
        <a class="collapse-item" routerLink="/order">Đơn hàng</a>
        <a class="collapse-item" routerLink="/purshase-suggestion">Đề xuất mua</a>
        <a class="collapse-item" routerLink="/invoice">Hóa đơn</a>
      </div>
    </div>
  </li>

  <!-- Accounting -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#accounting">
      <i class="fas fa-fw fa-calculator"></i>
      <span>Kế toán</span>
    </a>
    <div id="accounting" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <a class="collapse-item" routerLink="/budget">Ngân sách</a>
        <a class="collapse-item" routerLink="/fund">Quỹ</a>
      </div>
    </div>
  </li>

  <!-- Notices -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#notice">
      <i class="fas fa-fw fa-envelope"></i>
      <span>Thông báo</span>
    </a>
    <div id="notice" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <a class="collapse-item" routerLink="/notice">Thông báo</a>
        <a class="collapse-item" routerLink="/notice-template">Mẫu thông báo</a>
      </div>
    </div>
  </li>

  <!-- Identifications -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#identifications">
      <i class="fas fa-fw fa-fingerprint"></i>
      <span>Định danh</span>
    </a>
    <div class="collapse" id="identifications" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <a class="collapse-item" routerLink="/bar-code">Mã vạch</a>
        <a class="collapse-item" routerLink="/qr-code">Mã QR</a>
      </div>
    </div>
  </li>

  <!-- Setup -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#memberUtilities">
      <i class="fas fa-fw fa-tools"></i>
      <span>Cài đặt</span>
    </a>
    <div class="collapse" id="memberUtilities" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Vị trí:</h6>
        <a class="collapse-item" routerLink="/departement">Khu vực</a>
        <a class="collapse-item" routerLink="/shelf">Kệ</a>
        <a class="collapse-item" routerLink="/row">Hàng</a>

        <h6 class="collapse-header">Thuộc tính sách:</h6>
        <a class="collapse-item" routerLink="/physical-description">Mô tả vật lý</a>
      </div>
    </div>
  </li>

  <!-- Reports -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#rapportUtilities">
      <i class="fas fa-fw fa-comment-dollar"></i>
      <span>Báo cáo</span>
    </a>
    <div id="rapportUtilities" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <a class="collapse-item" routerLink="/book-report">Báo cáo sách</a>
        <a class="collapse-item" routerLink="/member-report">Báo cáo thành viên</a>
      </div>
    </div>
  </li>

  <!-- Analytics -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#analyticsUtilities">
      <i class="fas fa-fw fa-signal"></i>
      <span>Thống kê</span>
    </a>
    <div id="analyticsUtilities" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <a class="collapse-item" routerLink="/bookanalytics">Thống kê sách</a>
        <a class="collapse-item" routerLink="/account-analytics">Thống kê tài khoản</a>
      </div>
    </div>
  </li>

  <!-- Help -->
  <li class="nav-item active">
    <a class="nav-link" routerLink="/help">
      <i class="fas fa-fw fa-headset"></i>
      <span>Trợ giúp</span>
    </a>
  </li>

  <!-- Settings -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#settingsMenu">
      <i class="fas fa-fw fa-sliders-h"></i>
      <span>Cài đặt hệ thống</span>
    </a>
    <div id="settingsMenu" class="collapse" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <a class="collapse-item" routerLink="/settings">Cài đặt chung</a>
      </div>
    </div>
  </li>
</ul>